import * as React from "react";
import * as _ from "lodash";
import ProductSegmentsTable from "../../components/products/ProductSegmentTable";
import { useProductGroups } from "~/apps/pos/apis/productGroups";
import { navigate } from "~/router";
import { useProductGroupDeleteConfirm } from "../../components/products/useProductGroupDeleteConfirm";

const ProductGroupList = () => {
  const { page, pageSize, data, isLoading, handlePageChange } = useProductGroups();
  const { deleteConfirm, showDeleteConfirm } = useProductGroupDeleteConfirm();

  const handleEdit = (productGroup) => {
    navigate("pos.admin.products.groups.edit", { groupId: productGroup.id });
  };

  return (
    <>
      <ProductSegmentsTable
        loading={isLoading}
        page={page}
        pageSize={pageSize}
        data={data || []}
        onPageChange={handlePageChange}
        onEdit={handleEdit}
        onDelete={showDeleteConfirm}
      />
      {deleteConfirm}
    </>
  );
};

export default ProductGroupList;
